import styled from "styled-components";
import { isSomething } from "../../../../../../utils/utils";

export const CustomLinearBarStyled = styled.div`
  display: flex;
  /* padding: 0px 6px; */
  width: 100%;
  align-items: center;
  .main-linear-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    flex: 1 0;
    padding-top: 8px;
  }

  .transparent-linear-bar {
    height: 4px;
    background: #BDB5F8;
    width: ${(props) => {
      return !isSomething(props?.data?.transparent)
        ? "20%"
        : `${props?.data?.transparent}%`;
    }};
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }
  .red-linear-bar {
    height: 4px;
    background: var(--feedback-red-600, #ff5c5c);
    width: ${(props) => {
      return !isSomething(props?.data?.red) ? "10%" : `${props?.data?.red}%`;
    }};
  }
  .green-linear-bar {
    background: var(--feedback-green-600, #3820E9);
    height: 4px;
    width: ${(props) => {
      return !isSomething(props?.data?.green)
        ? "70%"
        : `${props?.data?.green}%`;
    }};
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }

  .not-available-text {
    font-size: 13px;
    font-weight: 400;
    color: #516382;
  }
`;
